import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '@yme/atoms/grid';
import { buildKey } from '@yme/common/index';
import { getTestRideDealerId, getTestRideIframe } from '@yme/components/TestRide/redux/selectors';
import { useWindowSize } from '@yme/hooks/index';
import { SegmentPreviewCard } from '@yme/molecules/cards';
import { OverlapContainer } from '@yme/molecules/overlap-container';
import { getUrlWithTestRideMode } from '@yme/organisms/test-ride-grid/helpers';
import { getPageBlockStrategy } from '@yme/selectors/common';
import { getRTL } from '@yme/selectors/index';
import { DigitalDataMutation, getLowerCaseValue, selectColorTheme, setDigitalData, } from '@yme/utils/common';
import { BOTTOM_INDENT_CONFIG, SEGMENT_SELECTOR_PANEL_ID } from './constants';
export function SegmentSelectorPanel(props) {
    const { cards } = props;
    const { isMobileView } = useWindowSize();
    const isRightToLeft = useSelector(getRTL);
    const pageBlockStrategy = useSelector(getPageBlockStrategy);
    const dealerId = useSelector(getTestRideDealerId);
    const isIframe = useSelector(getTestRideIframe);
    const isTracked = useRef(false);
    const brandedColor = selectColorTheme(pageBlockStrategy);
    const isSegmentSelectorPanelDataExist = cards && cards.length > 0;
    useEffect(() => {
        if (isSegmentSelectorPanelDataExist && !isTracked.current) {
            setDigitalData(DigitalDataMutation.SEGMENT_PANEL_LOAD, {
                segments: cards.map((item) => item.title),
            });
            isTracked.current = true;
        }
    }, [isTracked, isSegmentSelectorPanelDataExist, cards]);
    if (!isSegmentSelectorPanelDataExist) {
        return null;
    }
    const borderSize = isMobileView ? '4px' : '6px';
    return (React.createElement(OverlapContainer, { borderSize: borderSize, brandedColor: brandedColor, bottomIndent: BOTTOM_INDENT_CONFIG, isDefaultVerticalPadding: true, id: SEGMENT_SELECTOR_PANEL_ID, isRightToLeft: isRightToLeft },
        React.createElement(Row, { rowGap: "24px" }, cards.map((item, index) => {
            const clearedTitle = getLowerCaseValue(item.title);
            const key = buildKey(clearedTitle, index);
            const onSegmentClick = (item) => {
                return () => {
                    setDigitalData(DigitalDataMutation.SEGMENT_PANEL_CLICK, {
                        segmentName: item.title,
                        url: item.link,
                    });
                };
            };
            return (React.createElement(Col, { lg: 2, md: 2, sm: 2, key: key },
                React.createElement(SegmentPreviewCard, { isRightToLeft: isRightToLeft, title: item.title, imageObj: item.image, link: getUrlWithTestRideMode({
                        url: item.link,
                        dealerId,
                        isIframe,
                    }), onClick: onSegmentClick(item) })));
        }))));
}
SegmentSelectorPanel.displayName = 'SegmentSelectorPanel_AEMComponent';
